import React, { Component } from "react";

export default class IoTImg extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <svg width="800" height="524.284" viewBox="0 0 800 524.284">
        <g transform="translate(-1037.424 -460)">
          <path
            d="M714.382,676.631c-45.368,0-94.669-6.742-143.638-19.706-60.558-16.032-116.082-40.23-160.571-69.98l1.317-1.97c44.278,29.605,99.553,53.694,159.86,69.658,54.5,14.429,109.405,21.114,158.765,19.35l.086,2.369Q722.381,676.633,714.382,676.631Z"
            transform="translate(818.854 262.8)"
            fill="#090814"
          />
          <path
            d="M707.617,367c-14.735-4.8-29.888-9.264-45.045-13.276-87.214-23.089-172.947-31.287-247.933-23.7l-.239-2.359c75.265-7.609,161.291.6,248.779,23.77,15.2,4.025,30.4,8.5,45.173,13.315Z"
            transform="translate(818.826 264.511)"
            fill="#090814"
          />
          <path
            d="M306.964,551.74c-36.351-35.785-51.7-73.118-43.232-105.12,10.868-41.068,59.172-69.464,132.516-77.9l.271,2.356c-72.325,8.323-119.886,36.081-130.491,76.156-8.245,31.145,6.885,67.662,42.6,102.825Z"
            transform="translate(819.832 264.223)"
            fill="#090814"
          />
          <path
            d="M763.918,663.97l-.76-2.246c40.575-13.719,65.954-35.818,73.392-63.912C846,562.1,825.464,520.656,778.714,481.118c-46.989-39.739-114.748-72.713-190.8-92.846l.6-2.292c76.38,20.221,144.471,53.366,191.722,93.328,47.489,40.163,68.3,82.464,58.6,119.111C831.191,627.318,805.283,649.984,763.918,663.97Z"
            transform="translate(855.875 260.754)"
            fill="#090814"
          />
          <path
            d="M441.5,598.092c-.078-.014-.157-.025-.234-.039a6.368,6.368,0,0,0,.925-.7Z"
            transform="translate(818.65 262.719)"
            fill="#fff"
          />
          <path
            d="M910.367,362.092c.079-.014.157-.025.234-.039a6.378,6.378,0,0,1-.925-.7Z"
            transform="translate(815.569 264.272)"
            fill="#fff"
          />
          <path
            d="M343.5,295.092c-.079-.014-.157-.025-.234-.039a6.384,6.384,0,0,0,.925-.7Z"
            transform="translate(819.295 264.713)"
            fill="#fff"
          />
          <g transform="translate(1086.347 460)">
            <path
              d="M278.155,353.5c0,2.415.08,4.83.249,7.222.179,2.861.487,5.7.906,8.524a106.54,106.54,0,0,0,7.967,27.547l.6,1.308.3.656c.1.218.208.437.308.646.139.288.269.567.4.844.169.348.338.7.516,1.044.02.039.039.09.069.139.149.3.288.586.447.885a1.74,1.74,0,0,0,.1.189c.169.338.348.685.526,1.023.2.357.387.726.586,1.083.477.885.973,1.758,1.48,2.633q.223.388.457.775c.139.238.278.477.427.715.1.159.2.328.3.487.159.269.318.526.487.795.367.586.745,1.172,1.113,1.758h.01c.169.269.347.536.526.8v.01c.526.795,1.073,1.589,1.619,2.374h.007a.011.011,0,0,1,0,.007c.437.636.894,1.252,1.341,1.868v.01c.3.387.586.785.885,1.172.238.318.487.646.735.964.049.069.11.129.159.2v.01c.069.09.139.169.208.259q1.58,2.027,3.258,3.964l.179.208c.059.069.129.139.189.218.1.11.189.218.288.328s.189.218.288.328a107.906,107.906,0,0,0,19.7,17.375c.964.665,1.947,1.308,2.93,1.937.249.159.5.318.745.467.069.049.149.1.218.149.139.08.269.159.4.249s.259.159.4.238c.526.328,1.063.646,1.6.964.129.079.269.159.4.238s.269.149.4.228c0,.01,0,.01.01.01h.01v.01h.01q1,.581,2.027,1.132c.367.2.745.4,1.123.6.854.467,1.719.914,2.583,1.341.308.149.626.3.934.457.259.119.516.249.775.367.079.039.149.069.218.11.218.1.427.2.646.3.238.11.477.218.7.328.269.119.526.239.8.348.993.447,2,.874,3,1.281a105.129,105.129,0,0,0,11.007,3.815c.169.049.347.1.526.149q2.4.67,4.83,1.222,4.247.983,8.573,1.61h.02l1.034.149c.03,0,.059.01.1.01,0,.01,0,.01.01,0l1.142.149a.245.245,0,0,0,.08.01c.357.049.726.09,1.083.129l1.162.119.894.09a.192.192,0,0,0,.08.01c.269.02.536.049.805.069h.039l.7.059c2.771.218,5.553.318,8.375.318,3.05,0,6.079-.119,9.07-.377h.03l1.917-.179c.169-.02.328-.03.5-.049.03,0,.069-.01.1-.01.049-.01.1-.01.159-.02a.249.249,0,0,0,.08-.01c.218-.02.437-.049.665-.069l.745-.09c.249-.03.5-.069.745-.1.059-.01.11-.01.169-.02.179-.02.357-.049.536-.08l.259-.03c.179-.03.347-.049.526-.079h.01a105.005,105.005,0,0,0,16.093-3.623c.278-.09.557-.169.834-.259.01,0,.02-.01.03-.01.08-.03.169-.049.249-.08.745-.238,1.48-.487,2.214-.745,1.013-.338,2.013-.7,3.019-1.083.269-.11.536-.208.805-.318.546-.208,1.083-.427,1.619-.646.914-.367,1.828-.755,2.732-1.152.844-.377,1.679-.755,2.516-1.152.02-.01.049-.01.069-.03.189-.09.377-.179.556-.269h.01a106.488,106.488,0,0,0,13.2-7.54q2.027-1.356,3.993-2.8c1.053-.785,2.086-1.58,3.12-2.394a107.588,107.588,0,0,0,14.1-13.471v-.01c.308-.338.6-.685.894-1.034.049-.049.09-.1.129-.139.189-.228.367-.447.556-.665v-.01c.249-.288.5-.586.735-.885.059-.069.11-.129.159-.189v-.01c.2-.239.387-.477.586-.726.1-.119.189-.238.288-.357v-.01c.586-.735,1.152-1.47,1.719-2.225.149-.2.3-.4.457-.616.716-.964,1.409-1.947,2.086-2.93v-.01c.259-.367.5-.745.765-1.113l.745-1.132c.249-.4.5-.785.755-1.182l.03-.059c.249-.377.5-.775.735-1.162.189-.318.377-.626.567-.934.119-.208.249-.418.367-.636a2.392,2.392,0,0,0,.129-.208l.834-1.46c.328-.567.646-1.142.964-1.719.119-.238.249-.477.377-.715.049-.08.09-.159.129-.239.149-.278.3-.566.437-.854s.3-.567.447-.854.288-.567.427-.854c.11-.218.208-.437.318-.656a.214.214,0,0,1,.03-.049c.049-.11.1-.208.139-.308a.218.218,0,0,0,.03-.049c.11-.218.208-.447.318-.665.139-.288.269-.586.4-.875.09-.2.189-.4.278-.616.129-.288.269-.577.387-.874.139-.3.269-.6.4-.906a2.294,2.294,0,0,0,.1-.228c.069-.139.119-.278.179-.418.159-.367.318-.745.467-1.113.179-.418.348-.844.5-1.262.159-.387.308-.785.457-1.182l.059-.139a107.6,107.6,0,0,0,5.245-18.805v-.01a108.7,108.7,0,0,0,1.421-11.07c.01-.208.03-.4.04-.6.179-2.516.259-5.032.259-7.57,0-1.123-.02-2.235-.049-3.348a106.516,106.516,0,0,0-23.624-63.777c-.318-.4-.636-.8-.964-1.193s-.665-.785-.993-1.172a107.04,107.04,0,0,0-171.9,12.349c-.487.775-.973,1.56-1.44,2.345s-.934,1.589-1.391,2.394a106.57,106.57,0,0,0-13.686,52.4Z"
              transform="translate(-278.143 -246.478)"
              fill="#f2f2f2"
            />
            <g transform="translate(68.43 46.293)">
              <path
                d="M894.083,452.255q-.28,4.184-.559,8.361a134.207,134.207,0,0,1-1.9,17.39,38.063,38.063,0,0,1-5.151,13.676,20.336,20.336,0,0,1-11.438,8.71,20.957,20.957,0,0,1-8.874.194c-5.54-3.147-9.293.878-3.761,4.973a42.892,42.892,0,0,0,3.908,2.572l2.51,38.75-46.622-10.1,9.1-51.547a30.752,30.752,0,0,1-3.808-4.157c-5.214-6.923-7.008-15.945-6.667-24.6s2.657-17.11,4.95-25.463a65.507,65.507,0,0,1,2.114-6.69c1.018.42,2.051.8,3.1,1.119,6.706,2.035,13.831,2.2,20.839,2.191q18.707-.012,37.367-1.461a35.853,35.853,0,0,1,5.074,15.494,71.938,71.938,0,0,1-.179,10.591Z"
                transform="translate(-820.777 -424.321)"
                fill={theme.imageHighlight}
              />
              <path
                d="M913.769,451.1a36.941,36.941,0,0,0,3.22,22.334c1.25,2.547,2.8,5.617,1.276,8.012a4.935,4.935,0,0,1-3.717,2.06,12.1,12.1,0,0,1-4.338-.562"
                transform="translate(-840.718 -430.292)"
                fill={theme.imageHighlight}
              />
              <path
                d="M845.576,455.981a23.042,23.042,0,0,1-.769,5.975v.008c-.008.039-.023.078-.031.117-1.57,5.773-5.315,9.828-9.69,9.828-4.351,0-8.081-4.025-9.674-9.751-.109-.4-.2-.793-.288-1.2-.109-.458-.194-.931-.264-1.422-.062-.389-.109-.785-.148-1.189-.054-.559-.093-1.119-.1-1.7v-.008c-.015-.218-.015-.435-.015-.653v-.194l.008-.008a22.76,22.76,0,0,1,.194-2.945c.054-.412.117-.808.194-1.2.093-.483.194-.956.319-1.422.1-.412.218-.808.342-1.2.172-.528.358-1.041.567-1.531.132-.319.272-.629.412-.931,1.911-3.931,4.988-6.488,8.454-6.488,4.794,0,8.835,4.888,10.086,11.553.016.1.039.2.047.3v.008A22.991,22.991,0,0,1,845.576,455.981Z"
                transform="translate(-821.627 -427.83)"
                fill="#e6e6e6"
              />
              <path
                d="M827.2,448.745a.619.619,0,0,1-.513.59c.132-.319.272-.629.412-.931A.652.652,0,0,1,827.2,448.745Z"
                transform="translate(-822.095 -429.692)"
                fill={theme.imageHighlight}
              />
              <rect
                width="8.046"
                height="1.208"
                rx="0.604"
                transform="translate(6.851 18.345)"
                fill={theme.imageHighlight}
              />
              <path
                d="M826.731,452.169a.607.607,0,0,1-.606.606h-.606c.1-.412.218-.808.342-1.2h.264a.605.605,0,0,1,.606.6Z"
                transform="translate(-821.834 -430.397)"
                fill={theme.imageHighlight}
              />
              <rect
                width="2.308"
                height="1.208"
                rx="0.604"
                transform="translate(6.155 21.172)"
                fill={theme.imageHighlight}
              />
              <rect
                width="8.046"
                height="1.208"
                rx="0.604"
                transform="translate(10.207 21.072)"
                fill={theme.imageHighlight}
              />
              <rect
                width="2.308"
                height="1.208"
                rx="0.604"
                transform="translate(5.945 23.898)"
                fill={theme.imageHighlight}
              />
              <rect
                width="2.308"
                height="1.208"
                rx="0.604"
                transform="translate(9.511 23.898)"
                fill={theme.imageHighlight}
              />
              <path
                d="M826.521,455.549a.607.607,0,0,1-.606.606h-1.057c.054-.412.117-.808.194-1.2h.862a.6.6,0,0,1,.606.6Z"
                transform="translate(-821.686 -431.151)"
                fill={theme.imageHighlight}
              />
              <rect
                width="8.046"
                height="1.208"
                rx="0.604"
                transform="translate(13.562 23.798)"
                fill={theme.imageHighlight}
              />
              <path
                d="M826.735,460.666a.6.6,0,0,1-.606.6h-1.1a.615.615,0,0,1-.42-.163v-.008c-.015-.218-.015-.435-.015-.653v-.195l.008-.008a.6.6,0,0,1,.427-.179h1.1A.607.607,0,0,1,826.735,460.666Z"
                transform="translate(-821.628 -432.289)"
                fill="#ccc"
              />
              <rect
                width="8.046"
                height="1.208"
                rx="0.604"
                transform="translate(6.851 27.669)"
                fill="#ccc"
              />
              <path
                d="M826.561,464.169a.607.607,0,0,1-.606.606H824.9c-.062-.389-.109-.785-.148-1.189a.264.264,0,0,1,.109-.016h1.1A.605.605,0,0,1,826.561,464.169Z"
                transform="translate(-821.663 -433.073)"
                fill="#ccc"
              />
              <rect
                width="2.308"
                height="1.208"
                rx="0.604"
                transform="translate(6.155 30.496)"
                fill="#ccc"
              />
              <rect
                width="8.046"
                height="1.208"
                rx="0.604"
                transform="translate(10.207 30.396)"
                fill="#ccc"
              />
              <rect
                width="2.308"
                height="1.208"
                rx="0.604"
                transform="translate(5.945 33.222)"
                fill="#ccc"
              />
              <rect
                width="2.308"
                height="1.208"
                rx="0.604"
                transform="translate(9.511 33.222)"
                fill="#ccc"
              />
              <path
                d="M826.615,467.549a.607.607,0,0,1-.606.606h-.443c-.109-.4-.2-.793-.288-1.2h.732a.6.6,0,0,1,.606.6Z"
                transform="translate(-821.781 -433.826)"
                fill="#ccc"
              />
              <rect
                width="8.046"
                height="1.208"
                rx="0.604"
                transform="translate(13.562 33.122)"
                fill="#ccc"
              />
            </g>
          </g>
          <g transform="translate(1623.375 610.022)">
            <g transform="translate(0 0)">
              <path
                d="M974.3,420.5c0,2.415-.079,4.83-.248,7.222-.179,2.861-.487,5.7-.906,8.524a106.549,106.549,0,0,1-7.967,27.547l-.6,1.308-.3.656c-.1.218-.208.437-.308.646-.139.288-.269.567-.4.844-.169.348-.338.7-.516,1.044-.02.039-.039.09-.069.139-.149.3-.288.586-.447.885a1.775,1.775,0,0,1-.1.189c-.169.338-.348.685-.526,1.023-.2.357-.387.726-.586,1.083-.477.885-.973,1.758-1.48,2.633q-.223.388-.457.775c-.139.238-.278.477-.427.716-.1.159-.2.328-.3.487-.159.269-.318.526-.487.795-.367.586-.745,1.172-1.113,1.758h-.01c-.169.269-.348.536-.526.8v.01c-.526.8-1.073,1.589-1.619,2.374a.01.01,0,0,0-.007,0,.01.01,0,0,0,0,.007c-.437.636-.894,1.252-1.341,1.868v.01c-.3.387-.586.785-.885,1.172-.238.318-.487.646-.736.964-.049.069-.11.129-.159.2v.01c-.069.09-.139.169-.208.259q-1.58,2.027-3.258,3.964l-.179.208c-.059.069-.129.139-.189.218-.1.11-.189.218-.288.328s-.189.218-.288.328a107.9,107.9,0,0,1-19.7,17.375c-.963.665-1.947,1.308-2.931,1.937-.249.159-.5.318-.745.467-.069.049-.149.1-.218.149-.139.079-.269.159-.4.249s-.259.159-.4.239c-.526.328-1.063.646-1.6.964-.129.08-.269.159-.4.238s-.269.149-.4.229c0,.01,0,.01-.01.01h-.01v.01h-.01q-1,.581-2.027,1.132c-.367.2-.745.4-1.123.6-.854.467-1.719.914-2.583,1.341-.308.149-.626.3-.934.457-.259.119-.516.248-.775.367-.08.039-.149.069-.218.11-.218.1-.427.2-.646.3-.238.11-.477.218-.7.328-.269.119-.526.239-.8.347-.993.447-2,.875-3,1.281a105.2,105.2,0,0,1-11.007,3.815c-.169.049-.348.1-.526.149q-2.4.67-4.83,1.222-4.247.983-8.573,1.61h-.02l-1.033.149c-.03,0-.059.01-.1.01,0,.01,0,.01-.01,0l-1.142.149a.251.251,0,0,1-.079.01c-.357.049-.726.089-1.083.129l-1.162.119-.894.089a.191.191,0,0,1-.079.01c-.269.02-.537.049-.805.069h-.039l-.7.059c-2.771.218-5.553.318-8.375.318-3.05,0-6.08-.119-9.07-.377h-.03l-1.917-.179c-.169-.02-.328-.03-.5-.049-.03,0-.069-.01-.1-.01-.049-.01-.1-.01-.159-.02a.247.247,0,0,1-.08-.01c-.218-.02-.437-.049-.665-.069l-.745-.09c-.249-.03-.5-.069-.745-.1-.059-.01-.11-.01-.169-.02-.179-.02-.357-.049-.536-.079l-.259-.03c-.179-.03-.348-.049-.526-.079h-.01a105,105,0,0,1-16.093-3.623c-.278-.089-.556-.169-.834-.259-.01,0-.02-.01-.03-.01-.079-.03-.169-.049-.249-.079-.745-.239-1.48-.487-2.214-.745-1.013-.338-2.013-.7-3.019-1.083-.269-.11-.536-.208-.805-.318-.547-.208-1.083-.427-1.619-.646-.914-.367-1.828-.755-2.732-1.152-.844-.377-1.679-.755-2.516-1.152-.02-.01-.049-.01-.069-.03-.189-.09-.377-.179-.556-.269h-.01a106.489,106.489,0,0,1-13.2-7.54q-2.027-1.356-3.994-2.8c-1.053-.785-2.086-1.58-3.12-2.394a107.556,107.556,0,0,1-14.1-13.471v-.01c-.308-.338-.6-.685-.894-1.034-.049-.049-.09-.1-.129-.139-.189-.228-.367-.447-.556-.665v-.01c-.249-.288-.5-.586-.736-.885-.059-.069-.11-.129-.159-.189v-.01c-.2-.239-.388-.477-.586-.726-.1-.119-.189-.238-.288-.357v-.01c-.586-.735-1.152-1.47-1.719-2.225-.149-.2-.3-.4-.457-.616-.715-.964-1.409-1.947-2.086-2.93v-.01c-.259-.367-.5-.745-.765-1.113l-.745-1.132c-.249-.4-.5-.785-.755-1.182l-.03-.059c-.249-.377-.5-.775-.736-1.162-.189-.318-.377-.626-.567-.934-.119-.208-.249-.418-.367-.636a2.4,2.4,0,0,1-.129-.208l-.834-1.46c-.328-.567-.646-1.142-.964-1.719-.119-.239-.249-.477-.378-.716-.049-.08-.089-.159-.129-.239-.149-.278-.3-.566-.437-.854s-.3-.567-.447-.854-.288-.567-.427-.854c-.11-.218-.208-.437-.318-.656a.217.217,0,0,0-.03-.049c-.049-.11-.1-.208-.139-.308a.217.217,0,0,1-.03-.049c-.11-.218-.208-.447-.318-.665-.139-.288-.269-.586-.4-.874-.09-.2-.189-.4-.278-.616-.129-.288-.269-.577-.387-.874-.139-.3-.269-.6-.4-.906a2.267,2.267,0,0,1-.1-.228c-.07-.139-.119-.278-.179-.418-.159-.367-.318-.745-.467-1.113-.179-.418-.347-.844-.5-1.262-.159-.387-.308-.785-.457-1.182l-.059-.139a107.6,107.6,0,0,1-5.245-18.805v-.01a108.769,108.769,0,0,1-1.421-11.07c-.01-.208-.03-.4-.039-.6-.179-2.516-.259-5.032-.259-7.57,0-1.123.02-2.235.049-3.348a106.516,106.516,0,0,1,23.624-63.777c.318-.4.636-.8.964-1.193s.665-.785.993-1.172a107.04,107.04,0,0,1,171.9,12.349c.487.775.974,1.56,1.441,2.345s.934,1.589,1.391,2.394A106.568,106.568,0,0,1,974.3,420.5Z"
                transform="translate(-760.255 -313.48)"
                fill="#f2f2f2"
              />
              <g transform="translate(45.284 59.374)">
                <g transform="translate(24.868 27.521)">
                  <path
                    d="M116.9,145.025H78.588L59.433,178.2l19.155,33.177H116.9L136.052,178.2Z"
                    transform="translate(-59.433 -145.025)"
                    fill={theme.imageHighlight}
                  />
                  <path
                    d="M262.289,438.631h31.9l15.948-27.623-15.948-27.623h-31.9l-15.948,27.623Z"
                    transform="translate(-239.928 -377.831)"
                    fill="#fff"
                  />
                  <rect
                    width="0.415"
                    height="17.13"
                    transform="translate(25.993 5.513)"
                    fill="#3f3d56"
                  />
                  <circle
                    cx="1.181"
                    cy="1.181"
                    r="1.181"
                    transform="translate(25.019 22.446)"
                    fill={theme.imageHighlight}
                  />
                  <rect
                    width="0.415"
                    height="17.13"
                    transform="translate(34.853 5.513)"
                    fill="#3f3d56"
                  />
                  <circle
                    cx="1.181"
                    cy="1.181"
                    r="1.181"
                    transform="translate(33.879 22.446)"
                    fill="#3f3d56"
                  />
                  <rect
                    width="0.415"
                    height="17.13"
                    transform="translate(50.408 5.513)"
                    fill="#3f3d56"
                  />
                  <circle
                    cx="1.181"
                    cy="1.181"
                    r="1.181"
                    transform="translate(49.434 22.446)"
                    fill="#3f3d56"
                  />
                  <circle
                    cx="1.181"
                    cy="1.181"
                    r="1.181"
                    transform="translate(42.937 39.379)"
                    fill="#3f3d56"
                  />
                  <circle
                    cx="1.181"
                    cy="1.181"
                    r="1.181"
                    transform="translate(18.915 28.55)"
                    fill="#3f3d56"
                  />
                  <path
                    d="M237.665,255.333h-.415V234.691H228.4v-.415h9.265Z"
                    transform="translate(-193.34 -215.757)"
                    fill="#3f3d56"
                  />
                  <circle
                    cx="1.181"
                    cy="1.181"
                    r="1.181"
                    transform="translate(27.776 46.861)"
                    fill={theme.imageHighlight}
                  />
                  <path
                    d="M164.6,291.391h-.415V270.749h-8.85v-.415H164.6Z"
                    transform="translate(-135.436 -244.333)"
                    fill="#3f3d56"
                  />
                  <circle
                    cx="1.181"
                    cy="1.181"
                    r="1.181"
                    transform="translate(55.144 37.607)"
                    fill={theme.imageHighlight}
                  />
                  <path
                    d="M308.531,246.793h-.415V226.151h-5.7v-.415h6.114Z"
                    transform="translate(-251.998 -208.989)"
                    fill="#3f3d56"
                  />
                  <path
                    d="M155.7,243.418h-.415V233.155H161.6v.415h-5.9Z"
                    transform="translate(-135.396 -214.868)"
                    fill="#3f3d56"
                  />
                  <circle
                    cx="1.181"
                    cy="1.181"
                    r="1.181"
                    transform="translate(33.978 51.488)"
                    fill="#3f3d56"
                  />
                  <path
                    d="M205.771,353.964h-.415v-9.848h-5.9V343.7h6.311Z"
                    transform="translate(-170.405 -302.475)"
                    fill="#3f3d56"
                  />
                  <circle
                    cx="1.181"
                    cy="1.181"
                    r="1.181"
                    transform="translate(49.04 42.726)"
                    fill="#3f3d56"
                  />
                  <path
                    d="M300.886,311.74h-.415V301.477h6.311v.415h-5.9Z"
                    transform="translate(-250.456 -269.014)"
                    fill="#3f3d56"
                  />
                </g>
                <g transform="translate(0 0)">
                  <path
                    d="M359.265,159.982a.484.484,0,0,0-.484.484v15.481a.484.484,0,1,0,.968,0V160.466A.484.484,0,0,0,359.265,159.982Z"
                    transform="translate(-337.402 -159.004)"
                    fill="#3f3d56"
                  />
                  <g transform="translate(2.81 0)">
                    <path
                      d="M304.353,180.015h-20.34a1.993,1.993,0,0,1-1.991-1.991V157.931a1.993,1.993,0,0,1,1.991-1.991h20.34a1.993,1.993,0,0,1,1.991,1.991v20.093A1.993,1.993,0,0,1,304.353,180.015Z"
                      transform="translate(-282.022 -155.94)"
                      fill="#090814"
                    />
                    <path
                      d="M289.66,158.392a5.186,5.186,0,0,0-5.186,5.186v15.879a1.824,1.824,0,0,0,1.824,1.824h12.438a8.875,8.875,0,0,0,8.875-8.875v-12.19a1.824,1.824,0,0,0-1.824-1.824Z"
                      transform="translate(-283.881 -157.799)"
                      fill="#fff"
                    />
                    <g transform="translate(1.84 5.675)">
                      <path
                        d="M319.381,180.159H308.443a.379.379,0,0,1,0-.757h10.938a.379.379,0,1,1,0,.757Z"
                        transform="translate(-303.611 -179.401)"
                        fill="#d6d6e3"
                      />
                      <path
                        d="M319.381,213.523H308.443a.379.379,0,0,1,0-.757h10.938a.379.379,0,1,1,0,.757Z"
                        transform="translate(-303.611 -204.695)"
                        fill="#d6d6e3"
                      />
                      <path
                        d="M309.844,196.852H290.022a.379.379,0,1,1,0-.757h19.822a.379.379,0,0,1,0,.757Z"
                        transform="translate(-289.633 -192.057)"
                        fill="#d6d6e3"
                      />
                      <path
                        d="M350.362,227.089H343.2a.379.379,0,1,1,0-.757h7.161a.379.379,0,0,1,0,.757Z"
                        transform="translate(-329.949 -214.979)"
                        fill="#d6d6e3"
                      />
                    </g>
                  </g>
                  <circle
                    cx="3.387"
                    cy="3.387"
                    r="3.387"
                    transform="translate(0 19.601)"
                    fill={theme.imageHighlight}
                  />
                </g>
                <g transform="translate(7.058 73.155)">
                  <g transform="translate(0)">
                    <path
                      d="M109.939,164.318H97.994a1.171,1.171,0,0,1-1.169-1.169v-11.8a1.171,1.171,0,0,1,1.169-1.169h11.945a1.171,1.171,0,0,1,1.169,1.169v11.8a1.171,1.171,0,0,1-1.169,1.169Z"
                      transform="translate(-96.825 -150.18)"
                      fill="#090814"
                    />
                    <path
                      d="M101.309,151.619a3.045,3.045,0,0,0-3.045,3.046v9.325a1.071,1.071,0,0,0,1.071,1.071h7.3a5.211,5.211,0,0,0,5.211-5.211v-7.159a1.071,1.071,0,0,0-1.071-1.071h-9.469Z"
                      transform="translate(-97.916 -151.271)"
                      fill="#fff"
                    />
                    <g transform="translate(1.087 3.334)">
                      <path
                        d="M118.746,164.407h-6.424a.222.222,0,0,1,0-.445h6.424a.222.222,0,0,1,0,.445Z"
                        transform="translate(-109.492 -163.962)"
                        fill="#d6d6e3"
                      />
                      <path
                        d="M118.746,183.995h-6.424a.222.222,0,1,1,0-.445h6.424a.222.222,0,1,1,0,.445Z"
                        transform="translate(-109.492 -178.812)"
                        fill="#d6d6e3"
                      />
                      <path
                        d="M113.181,174.207H101.54a.222.222,0,0,1,0-.445h11.641a.222.222,0,0,1,0,.445Z"
                        transform="translate(-101.318 -171.391)"
                        fill="#d6d6e3"
                      />
                      <path
                        d="M136.974,191.962h-4.205a.222.222,0,1,1,0-.445h4.205a.222.222,0,0,1,0,.445Z"
                        transform="translate(-124.993 -184.852)"
                        fill="#d6d6e3"
                      />
                    </g>
                  </g>
                  <circle
                    cx="2.419"
                    cy="2.419"
                    r="2.419"
                    transform="translate(11.449 11.841)"
                    fill={theme.imageHighlight}
                  />
                </g>
                <g transform="translate(103.125 26.374)">
                  <g transform="translate(0 2.902)">
                    <path
                      d="M142.134,361.057H125.982a1.583,1.583,0,0,1-1.581-1.581V343.521a1.583,1.583,0,0,1,1.581-1.581h16.152a1.583,1.583,0,0,1,1.581,1.581v15.955a1.583,1.583,0,0,1-1.581,1.581h0Z"
                      transform="translate(-124.401 -341.94)"
                      fill="#090814"
                    />
                    <path
                      d="M130.466,343.887a4.118,4.118,0,0,0-4.118,4.118v12.609a1.448,1.448,0,0,0,1.448,1.448h9.877a7.047,7.047,0,0,0,7.047-7.047v-9.68a1.448,1.448,0,0,0-1.448-1.448H130.466Z"
                      transform="translate(-125.877 -343.416)"
                      fill="#fff"
                    />
                    <g transform="translate(1.459 4.506)">
                      <path
                        d="M154.021,361.168h-8.685a.3.3,0,1,1,0-.6h8.685a.3.3,0,1,1,0,.6Z"
                        transform="translate(-141.497 -360.566)"
                        fill="#d6d6e3"
                      />
                      <path
                        d="M154.069,387.661h-8.685a.3.3,0,0,1,0-.6h8.685a.3.3,0,1,1,0,.6Z"
                        transform="translate(-141.545 -380.651)"
                        fill="#d6d6e3"
                      />
                      <path
                        d="M146.489,374.424H130.747a.3.3,0,1,1,0-.6h15.742a.3.3,0,1,1,0,.6Z"
                        transform="translate(-130.437 -370.616)"
                        fill="#d6d6e3"
                      />
                      <path
                        d="M178.669,398.433h-5.685a.3.3,0,1,1,0-.6h5.685a.3.3,0,1,1,0,.6Z"
                        transform="translate(-162.457 -388.817)"
                        fill="#d6d6e3"
                      />
                    </g>
                  </g>
                  <circle
                    cx="2.903"
                    cy="2.903"
                    r="2.903"
                    transform="translate(15.434 0)"
                    fill={theme.imageHighlight}
                  />
                </g>
                <g transform="translate(101.487 50.004)">
                  <circle
                    cx="1.451"
                    cy="1.451"
                    r="1.451"
                    transform="translate(10.357 0)"
                    fill="#090814"
                  />
                  <path
                    d="M277.466,325.526H289.5V319.97h-.484v5.073H277.465Z"
                    transform="translate(-277.465 -318.519)"
                    fill="#090814"
                  />
                </g>
                <g transform="translate(24.403 25.569)">
                  <circle
                    cx="1.451"
                    cy="1.451"
                    r="1.451"
                    transform="translate(0 0)"
                    fill="#090814"
                  />
                  <path
                    d="M124.444,309.042H112.409v-5.556h.484v5.073h11.552Z"
                    transform="translate(-111.328 -302.034)"
                    fill="#090814"
                  />
                </g>
                <g transform="translate(13.873 64.621)">
                  <circle
                    cx="1.451"
                    cy="1.451"
                    r="1.451"
                    transform="translate(0 4.104)"
                    fill="#090814"
                  />
                  <path
                    d="M289.5,319.97H277.465v5.556h.484v-5.072H289.5Z"
                    transform="translate(-276.241 -319.97)"
                    fill="#090814"
                  />
                </g>
              </g>
            </g>
          </g>
          <g transform="translate(1520.616 869.862) rotate(-8)">
            <g transform="translate(33.747 0) rotate(19)">
              <path
                d="M81.745,103.656H9.27A9.28,9.28,0,0,1,0,94.385V9.27A9.28,9.28,0,0,1,9.27,0H76.7L91.012,11.413V94.385a9.28,9.28,0,0,1-9.27,9.271Z"
                transform="translate(0 0)"
                fill="#090814"
              />
              <path
                d="M6.6,0A6.609,6.609,0,0,0,0,6.6V91.717a6.609,6.609,0,0,0,6.6,6.6H79.074a6.609,6.609,0,0,0,6.6-6.6V10.03L73.094,0Z"
                transform="translate(2.669 2.669)"
                fill="#f2f2f2"
              />
              <path
                d="M34.54,3.085h-33A1.543,1.543,0,0,1,1.543,0h33a1.543,1.543,0,1,1,0,3.085Z"
                transform="translate(33.108 24.331)"
                fill={theme.imageHighlight}
              />
              <path
                d="M40.908,3.085H1.543A1.543,1.543,0,0,1,1.543,0H40.908a1.543,1.543,0,0,1,0,3.085Z"
                transform="translate(33.108 29.54)"
                fill={theme.imageHighlight}
              />
              <path
                d="M34.54,0h-33a1.543,1.543,0,0,0,0,3.085h33A1.543,1.543,0,1,0,34.54,0Z"
                transform="translate(33.109 47.678)"
                fill="#ccc"
              />
              <path
                d="M40.908,0H1.543a1.543,1.543,0,0,0,0,3.085H40.907a1.543,1.543,0,1,0,0-3.085Z"
                transform="translate(33.109 52.889)"
                fill="#ccc"
              />
              <path
                d="M34.54,3.085h-33A1.543,1.543,0,0,1,1.543,0h33a1.543,1.543,0,1,1,0,3.085Z"
                transform="translate(33.108 71.028)"
                fill="#ccc"
              />
              <path
                d="M40.908,3.085H1.543A1.543,1.543,0,0,1,1.543,0H40.908a1.543,1.543,0,0,1,0,3.085Z"
                transform="translate(33.108 76.238)"
                fill="#ccc"
              />
              <circle
                cx="5.456"
                cy="5.456"
                r="5.456"
                transform="translate(15.455 23.023)"
                fill={theme.imageHighlight}
              />
              <path
                d="M1.852,4.149a.566.566,0,0,1-.341-.113l-.006,0L.223,3.051a.57.57,0,1,1,.694-.9l.831.637L3.71.223a.569.569,0,0,1,.8-.105h0L4.494.134,4.509.117a.57.57,0,0,1,.105.8L2.305,3.927a.57.57,0,0,1-.453.222Z"
                transform="translate(18.518 26.411)"
                fill="#fff"
              />
              <path
                d="M10.911,5.456a5.456,5.456,0,0,1-5.455,5.458,1.172,1.172,0,0,1-.14-.005,5.455,5.455,0,1,1,5.6-5.453Z"
                transform="translate(16.017 46.371)"
                fill={theme.imageHighlight}
              />
              <circle
                cx="5.456"
                cy="5.456"
                r="5.456"
                transform="translate(15.455 69.72)"
                fill={theme.imageHighlight}
              />
              <path
                d="M14.3,11.564H3.085A3.085,3.085,0,0,1,0,8.479V.193A.193.193,0,0,1,.313.041L14.424,11.219a.193.193,0,0,1-.12.344Z"
                transform="translate(76.432 0.216)"
                fill="#090814"
              />
            </g>
          </g>
          <g transform="translate(1415.565 545.326)">
            <path
              d="M415.556,239.658,344.31,258a9.421,9.421,0,0,1-11.46-6.766L311.3,167.564a9.421,9.421,0,0,1,6.766-11.46l66.283-17.068,16.964,7.595,21,81.57A9.421,9.421,0,0,1,415.556,239.658Z"
              transform="translate(-311.007 -139.036)"
              fill="#090814"
            />
            <path
              d="M325.533,165.9a6.709,6.709,0,0,0-4.818,8.16l21.547,83.674a6.709,6.709,0,0,0,8.16,4.818l71.246-18.35a6.709,6.709,0,0,0,4.818-8.16l-20.677-80.3L390.9,149.07Z"
              transform="translate(-317.795 -146.206)"
              fill="#f2f2f2"
            />
            <path
              d="M584.594,147.627l-11.03,2.84a3.132,3.132,0,0,1-3.817-2.254l-2.1-8.144a.2.2,0,0,1,.272-.228l16.7,7.417a.2.2,0,0,1-.03.369Z"
              transform="translate(-494.464 -139.599)"
              fill="#090814"
            />
            <path
              d="M520.51,410.032l-32.437,8.354a1.567,1.567,0,0,1-.782-3.035L519.729,407a1.567,1.567,0,0,1,.782,3.035Z"
              transform="translate(-436.181 -330.549)"
              fill="#ccc"
            />
            <path
              d="M531.4,422.34l-38.7,9.965a1.567,1.567,0,1,1-.782-3.035l38.7-9.965a1.567,1.567,0,1,1,.782,3.035Z"
              transform="translate(-439.487 -339.348)"
              fill="#ccc"
            />
            <circle
              cx="5.539"
              cy="5.539"
              r="5.539"
              transform="translate(33.114 86.818)"
              fill={theme.imageHighlight}
            />
            <path
              d="M448.833,255.1l-43.082,11.09a4.853,4.853,0,0,1-5.9-3.486l-9.028-35.072a4.853,4.853,0,0,1,3.487-5.9l43.08-11.089a4.853,4.853,0,0,1,5.9,3.487l9.028,35.072A4.853,4.853,0,0,1,448.833,255.1Z"
              transform="translate(-367.952 -190.111)"
              fill="#fff"
            />
            <path
              d="M448.833,255.1l-43.082,11.09a4.853,4.853,0,0,1-5.9-3.486l-9.028-35.072a4.853,4.853,0,0,1,3.487-5.9l43.08-11.089a4.853,4.853,0,0,1,5.9,3.487l9.028,35.072A4.853,4.853,0,0,1,448.833,255.1ZM394.45,222.282a4.282,4.282,0,0,0-3.075,5.209l9.028,35.072a4.282,4.282,0,0,0,5.209,3.075l43.078-11.091a4.282,4.282,0,0,0,3.075-5.209l-9.027-35.072a4.282,4.282,0,0,0-5.209-3.075Z"
              transform="translate(-367.952 -190.111)"
              fill="#e6e6e6"
            />
            <path
              d="M489.884,248.5l-21.742,5.6a.779.779,0,0,1-.944-.49.749.749,0,0,1,.528-.953l22.132-5.7c.894.453.658,1.379.025,1.543Z"
              transform="translate(-422.635 -216.184)"
              fill="#f2f2f2"
            />
            <path
              d="M493.324,261.876l-21.742,5.6a.779.779,0,0,1-.944-.49.749.749,0,0,1,.528-.953l22.132-5.7c.894.453.659,1.379.024,1.543Z"
              transform="translate(-425.094 -225.742)"
              fill="#f2f2f2"
            />
            <path
              d="M435.184,273.439l-6.635,1.708a.844.844,0,0,1-1.027-.607l-2.016-7.829a.844.844,0,0,1,.607-1.027l6.635-1.708a.845.845,0,0,1,1.027.607l2.016,7.829a.843.843,0,0,1-.607,1.027Z"
              transform="translate(-392.836 -228.328)"
              fill={theme.imageHighlight}
            />
            <path
              d="M471.474,289.318l-33.182,8.542a.779.779,0,0,1-.944-.489.749.749,0,0,1,.528-.953l33.572-8.642c.894.453.659,1.379.024,1.543Z"
              transform="translate(-401.296 -245.36)"
              fill="#f2f2f2"
            />
            <path
              d="M474.918,302.7l-33.183,8.542a.779.779,0,0,1-.944-.489.749.749,0,0,1,.528-.953l33.576-8.642c.894.453.659,1.379.025,1.543Z"
              transform="translate(-403.758 -254.923)"
              fill="#f2f2f2"
            />
            <path
              d="M478.359,316.065l-33.182,8.542a.779.779,0,0,1-.944-.49.749.749,0,0,1,.528-.953l33.572-8.642C479.229,314.975,478.99,315.9,478.359,316.065Z"
              transform="translate(-406.218 -264.48)"
              fill="#f2f2f2"
            />
            <path
              d="M481.8,329.442l-33.182,8.542a.779.779,0,0,1-.944-.489.749.749,0,0,1,.528-.953l33.573-8.641C482.672,328.352,482.436,329.279,481.8,329.442Z"
              transform="translate(-408.679 -274.043)"
              fill="#f2f2f2"
            />
            <path
              d="M485.244,342.812l-33.182,8.542a.779.779,0,0,1-.944-.49.749.749,0,0,1,.528-.953l33.572-8.642C486.113,341.722,485.878,342.652,485.244,342.812Z"
              transform="translate(-411.139 -283.6)"
              fill="#f2f2f2"
            />
            <path
              d="M442.4,457.986a.574.574,0,0,1-.364-.025h-.007l-1.509-.64a.579.579,0,0,1,.453-1.065l.978.416,1.281-3.014a.578.578,0,0,1,.759-.306h0l-.008.02.008-.02a.579.579,0,0,1,.306.758l-1.507,3.54a.579.579,0,0,1-.389.333Z"
              transform="translate(-403.339 -363.688)"
              fill="#fff"
            />
          </g>
          <g transform="translate(1311.768 693.514)">
            <rect
              width="215.409"
              height="146.217"
              transform="translate(0 0)"
              fill="#fff"
            />
            <path
              d="M795.571,452.056H592.49c-3.377,0-6.113-1.482-6.117-3.308V411.7c0-1.826,2.74-3.306,6.117-3.308H795.571c3.377,0,6.113,1.482,6.117,3.308v37.051C801.684,450.574,798.948,452.054,795.571,452.056Z"
              transform="translate(-586.29 -408.332)"
              fill={theme.imageHighlight}
            />
            <rect
              width="53.829"
              height="6.117"
              transform="translate(31.892 18.406)"
              fill="#f2f2f2"
            />
            <circle
              cx="3.67"
              cy="3.67"
              r="3.67"
              transform="translate(153.006 18.406)"
              fill="#f2f2f2"
            />
            <circle
              cx="3.67"
              cy="3.67"
              r="3.67"
              transform="translate(165.239 18.406)"
              fill="#f2f2f2"
            />
            <circle
              cx="3.67"
              cy="3.67"
              r="3.67"
              transform="translate(177.473 18.406)"
              fill="#f2f2f2"
            />
            <path
              d="M795.571,565.11H592.49c-3.377,0-6.113-1.482-6.117-3.308V524.75c0-1.826,2.74-3.306,6.117-3.308H795.571c3.377,0,6.113,1.482,6.117,3.308V561.8C801.684,563.628,798.948,565.108,795.571,565.11Z"
              transform="translate(-586.29 -469.826)"
              fill="#e6e6e6"
            />
            <rect
              width="53.829"
              height="6.117"
              transform="translate(31.892 69.966)"
              fill={theme.imageHighlight}
            />
            <circle
              cx="3.67"
              cy="3.67"
              r="3.67"
              transform="translate(153.006 69.966)"
              fill={theme.imageHighlight}
            />
            <circle
              cx="3.67"
              cy="3.67"
              r="3.67"
              transform="translate(165.239 69.966)"
              fill={theme.imageHighlight}
            />
            <circle
              cx="3.67"
              cy="3.67"
              r="3.67"
              transform="translate(177.473 69.966)"
              fill={theme.imageHighlight}
            />
            <path
              d="M795.571,678.164H592.49c-3.377,0-6.113-1.482-6.117-3.308V637.8c0-1.826,2.74-3.306,6.117-3.308H795.571c3.377,0,6.113,1.482,6.117,3.308v37.051C801.684,676.682,798.948,678.162,795.571,678.164Z"
              transform="translate(-586.29 -531.32)"
              fill="#e6e6e6"
            />
            <rect
              width="53.829"
              height="6.117"
              transform="translate(31.892 121.527)"
              fill={theme.imageHighlight}
            />
            <circle
              cx="3.67"
              cy="3.67"
              r="3.67"
              transform="translate(153.006 121.527)"
              fill={theme.imageHighlight}
            />
            <circle
              cx="3.67"
              cy="3.67"
              r="3.67"
              transform="translate(165.239 121.527)"
              fill={theme.imageHighlight}
            />
            <circle
              cx="3.67"
              cy="3.67"
              r="3.67"
              transform="translate(177.473 121.527)"
              fill={theme.imageHighlight}
            />
          </g>
          <g transform="translate(1037.424 757.943)">
            <path
              d="M376.155,656.5c0,2.415.079,4.83.249,7.222.179,2.861.487,5.7.906,8.523a106.547,106.547,0,0,0,7.967,27.547l.6,1.308.3.655c.1.218.208.437.308.646.139.288.269.567.4.844.169.347.338.7.516,1.043.02.039.039.089.069.139.149.3.288.586.447.885a1.744,1.744,0,0,0,.1.189c.169.338.347.685.526,1.023.2.357.388.726.586,1.083.477.885.973,1.758,1.48,2.633.149.259.3.516.457.775.139.239.278.477.427.716.1.159.2.328.3.487.159.269.318.526.487.795.367.586.745,1.172,1.113,1.758h.01c.169.269.348.536.526.795v.01c.526.795,1.073,1.589,1.619,2.374a.01.01,0,0,1,.01.01c.437.636.894,1.252,1.341,1.868v.01c.3.387.586.785.885,1.172.239.318.487.646.735.964.049.069.11.129.159.2v.01c.069.09.139.169.208.259q1.58,2.027,3.259,3.964l.179.208c.059.069.129.139.189.218.1.11.189.218.288.328s.189.218.288.328a107.9,107.9,0,0,0,19.7,17.375c.964.665,1.947,1.308,2.93,1.937.249.159.5.318.745.467.069.049.149.1.218.149.139.079.269.159.4.249s.259.159.4.238c.526.328,1.063.646,1.6.964.129.079.269.159.4.238s.269.149.4.228c0,.01,0,.01.01.01h.01v.01h.01q1,.581,2.027,1.132c.367.2.745.4,1.123.6.854.467,1.719.914,2.583,1.341.308.149.626.3.934.457.259.119.516.249.775.367.079.039.149.069.218.11.218.1.427.2.646.3.239.11.477.218.7.328.269.119.526.239.8.347.993.447,2,.874,3,1.281a105.182,105.182,0,0,0,11.007,3.815c.169.049.348.1.526.149q2.4.67,4.83,1.222,4.247.983,8.573,1.61h.02l1.034.149c.03,0,.059.01.1.01,0,.01,0,.01.01,0l1.142.149a.248.248,0,0,0,.08.01c.357.049.726.09,1.083.129l1.162.119.894.089a.192.192,0,0,0,.08.01c.269.02.536.049.805.069h.04l.7.059c2.771.218,5.553.318,8.375.318,3.05,0,6.08-.119,9.07-.377h.03l1.917-.179c.169-.02.328-.03.5-.049.03,0,.069-.01.1-.01.049-.01.1-.01.159-.02a.247.247,0,0,0,.079-.01c.218-.02.437-.049.665-.069l.745-.09c.249-.03.5-.069.745-.1.059-.01.11-.01.169-.02.179-.02.357-.049.536-.079l.259-.03c.179-.03.348-.049.526-.079h.01a105.017,105.017,0,0,0,16.093-3.623c.278-.09.556-.169.834-.259.01,0,.02-.01.03-.01.08-.03.169-.049.249-.079.745-.239,1.48-.487,2.214-.745,1.013-.338,2.013-.7,3.019-1.083.269-.11.536-.208.805-.318.547-.208,1.083-.427,1.619-.646.914-.367,1.827-.755,2.732-1.152.844-.377,1.679-.755,2.516-1.152.02-.01.049-.01.069-.03.189-.09.377-.179.556-.269h.01a106.516,106.516,0,0,0,13.2-7.54q2.027-1.355,3.993-2.8c1.053-.785,2.086-1.58,3.12-2.394a107.577,107.577,0,0,0,14.1-13.471v-.01c.308-.338.6-.685.894-1.033.049-.049.09-.1.129-.139.189-.229.367-.447.556-.665v-.01c.249-.288.5-.586.735-.885.059-.069.11-.129.159-.189v-.01c.2-.239.388-.477.586-.726.1-.119.189-.239.288-.357v-.01c.586-.736,1.152-1.47,1.719-2.225.149-.2.3-.4.457-.616.715-.964,1.409-1.947,2.086-2.93v-.01c.259-.367.5-.745.765-1.113l.745-1.132c.249-.4.5-.785.755-1.183l.03-.059c.249-.377.5-.775.735-1.162.189-.318.377-.626.567-.934.119-.208.249-.418.367-.636a2.358,2.358,0,0,0,.129-.208l.834-1.46c.328-.567.646-1.142.964-1.719.119-.239.249-.477.377-.716.049-.079.089-.159.129-.238.149-.278.3-.567.437-.854s.3-.567.447-.854.288-.566.427-.854c.11-.218.208-.437.318-.655a.212.212,0,0,1,.03-.049c.049-.11.1-.208.139-.308a.212.212,0,0,0,.03-.049c.11-.218.208-.447.318-.665.139-.288.269-.586.4-.874.09-.2.189-.4.278-.616.129-.288.269-.577.387-.875.139-.3.269-.6.4-.906a2.283,2.283,0,0,0,.1-.228c.069-.139.119-.278.179-.418.159-.367.318-.745.467-1.113.179-.418.347-.844.5-1.262.159-.387.308-.785.457-1.182l.059-.139a107.611,107.611,0,0,0,5.245-18.805v-.01a108.741,108.741,0,0,0,1.421-11.07c.01-.208.03-.4.039-.6.179-2.516.259-5.032.259-7.57,0-1.123-.02-2.235-.049-3.348a106.515,106.515,0,0,0-23.624-63.778c-.318-.4-.636-.8-.964-1.193s-.665-.785-.993-1.172a107.04,107.04,0,0,0-171.9,12.349c-.487.775-.973,1.56-1.44,2.345s-.934,1.589-1.391,2.394a106.57,106.57,0,0,0-13.677,52.4Z"
              transform="translate(-376.155 -549.478)"
              fill="#f2f2f2"
            />
            <g transform="translate(42.455 62.981)">
              <rect
                width="3.088"
                height="0.545"
                transform="translate(49.317 98.8)"
                fill="#b6b3c5"
              />
              <rect
                width="3.088"
                height="0.545"
                transform="translate(76.65 98.891)"
                fill="#b6b3c5"
              />
              <path
                d="M249.155,370.945a4.449,4.449,0,0,1-8.779,0h-11.23v24.337h31.239V370.945Z"
                transform="translate(-180.2 -296.392)"
                fill="#d6d6e3"
              />
              <rect
                width="31.238"
                height="0.847"
                transform="translate(49.037 96.962)"
                fill="#090814"
              />
              <path
                d="M127.388,97.1H1.741A1.743,1.743,0,0,1,0,95.359V23.653a1.743,1.743,0,0,1,1.741-1.742H127.388a1.744,1.744,0,0,1,1.742,1.741V95.359A1.744,1.744,0,0,1,127.388,97.1Z"
                transform="translate(0 -21.911)"
                fill="#090814"
              />
              <rect
                width="122.955"
                height="69.378"
                transform="translate(2.926 2.756)"
                fill="#fff"
              />
              <g transform="translate(42.565 11.384)">
                <g transform="translate(9.109 0)">
                  <path
                    d="M16.621,24.749A5.621,5.621,0,0,1,11,19.127V17.62A5.621,5.621,0,0,1,16.621,12a.342.342,0,1,1,0,.684,4.937,4.937,0,0,0-4.937,4.937v1.507a4.937,4.937,0,1,0,9.874,0V16.414a.342.342,0,1,1,.684,0v2.714a5.621,5.621,0,0,1-5.622,5.622Z"
                    transform="translate(1.549 3.083)"
                  />
                  <path
                    d="M9.62,24.75A5.621,5.621,0,0,1,4,19.129V16.415a.342.342,0,1,1,.684,0v2.714a4.937,4.937,0,1,0,9.874,0V17.621A4.937,4.937,0,0,0,9.62,12.685a.342.342,0,0,1,0-.684,5.621,5.621,0,0,1,5.62,5.62v1.507A5.621,5.621,0,0,1,9.619,24.75Z"
                    transform="translate(-2.008 3.082)"
                  />
                  <path
                    d="M21.9,12.186a.342.342,0,0,1-.342-.342V7.621a4.937,4.937,0,0,0-9.874,0,.342.342,0,1,1-.684,0,5.621,5.621,0,1,1,11.241,0v4.223A.342.342,0,0,1,21.9,12.186Z"
                    transform="translate(1.549 -2)"
                  />
                  <path
                    d="M14.9,23.045a.342.342,0,0,1-.342-.342V7.621a4.937,4.937,0,1,0-9.874,0v4.223a.342.342,0,0,1-.684,0V7.621a5.621,5.621,0,1,1,11.241,0V22.7A.342.342,0,0,1,14.9,23.045Z"
                    transform="translate(-2.009 -2)"
                  />
                  <g transform="translate(17.819 3.017)">
                    <path
                      d="M17.126,19.241a.342.342,0,1,1,0-.684,4.937,4.937,0,0,0,0-9.874h-.754a.342.342,0,0,1,0-.684h.754a5.621,5.621,0,1,1,0,11.241Z"
                      transform="translate(-14.784 -1.967)"
                    />
                    <path
                      d="M16.8,14.716a.342.342,0,1,1,0-.684,2.675,2.675,0,1,0,0-5.349h-.431a.342.342,0,0,1,0-.684H16.8a3.358,3.358,0,1,1,0,6.717Z"
                      transform="translate(-16.021 -8)"
                    />
                    <path
                      d="M16.743,14.716h-.431a.342.342,0,1,1,0-.684h.431a2.675,2.675,0,1,0,0-5.349.342.342,0,0,1,0-.684,3.358,3.358,0,1,1,0,6.717Z"
                      transform="translate(-15.961 8.248)"
                    />
                  </g>
                  <g transform="translate(0 3.017)">
                    <path
                      d="M21.62,19.241A5.621,5.621,0,1,1,21.62,8h.754a.342.342,0,1,1,0,.684H21.62a4.937,4.937,0,0,0,0,9.874.342.342,0,0,1,0,.684Z"
                      transform="translate(-15.999 -1.967)"
                    />
                    <path
                      d="M19.357,14.716a3.358,3.358,0,1,1,0-6.717h.431a.342.342,0,1,1,0,.684h-.431a2.675,2.675,0,1,0,0,5.349.342.342,0,0,1,0,.684Z"
                      transform="translate(-12.177 -7.999)"
                    />
                    <path
                      d="M19.788,14.716h-.431a3.358,3.358,0,1,1,0-6.717.342.342,0,1,1,0,.684,2.675,2.675,0,1,0,0,5.349h.431a.342.342,0,1,1,0,.684Z"
                      transform="translate(-12.176 8.249)"
                    />
                  </g>
                </g>
                <g transform="translate(0 34.503)">
                  <rect
                    width="6.788"
                    height="1.634"
                    rx="0.817"
                    transform="translate(8.548)"
                    fill={theme.imageHighlight}
                  />
                  <rect
                    width="2.388"
                    height="1.634"
                    rx="0.817"
                    transform="translate(36.456)"
                    fill={theme.imageHighlight}
                  />
                  <rect
                    width="2.388"
                    height="1.634"
                    rx="0.817"
                    transform="translate(41.233)"
                    fill={theme.imageHighlight}
                  />
                  <rect
                    width="16.217"
                    height="1.634"
                    rx="0.817"
                    transform="translate(17.725)"
                    fill={theme.imageHighlight}
                  />
                  <rect
                    width="6.788"
                    height="1.634"
                    rx="0.817"
                    transform="translate(0 10.56)"
                    fill={theme.imageHighlight}
                  />
                  <rect
                    width="2.388"
                    height="1.634"
                    rx="0.817"
                    transform="translate(27.908 10.56)"
                    fill={theme.imageHighlight}
                  />
                  <rect
                    width="2.388"
                    height="1.634"
                    rx="0.817"
                    transform="translate(32.685 10.56)"
                    fill={theme.imageHighlight}
                  />
                  <rect
                    width="16.217"
                    height="1.634"
                    rx="0.817"
                    transform="translate(9.177 10.56)"
                    fill={theme.imageHighlight}
                  />
                  <rect
                    width="6.788"
                    height="1.634"
                    rx="0.817"
                    transform="translate(28.034 3.646)"
                    fill={theme.imageHighlight}
                  />
                  <rect
                    width="6.788"
                    height="1.634"
                    rx="0.817"
                    transform="translate(0 3.646)"
                    fill={theme.imageHighlight}
                  />
                  <rect
                    width="2.388"
                    height="1.634"
                    rx="0.817"
                    transform="translate(0)"
                    fill={theme.imageHighlight}
                  />
                  <rect
                    width="2.388"
                    height="1.634"
                    rx="0.817"
                    transform="translate(0 7.165)"
                    fill={theme.imageHighlight}
                  />
                  <rect
                    width="16.217"
                    height="1.634"
                    rx="0.817"
                    transform="translate(9.554 3.646)"
                    fill={theme.imageHighlight}
                  />
                  <rect
                    width="6.788"
                    height="1.634"
                    rx="0.817"
                    transform="translate(13.954 7.165)"
                    fill={theme.imageHighlight}
                  />
                  <rect
                    width="6.788"
                    height="1.634"
                    rx="0.817"
                    transform="translate(4.777 7.165)"
                    fill={theme.imageHighlight}
                  />
                  <rect
                    width="2.388"
                    height="1.634"
                    rx="0.817"
                    transform="translate(4.28)"
                    fill={theme.imageHighlight}
                  />
                  <rect
                    width="2.388"
                    height="1.634"
                    rx="0.817"
                    transform="translate(41.61 7.165)"
                    fill={theme.imageHighlight}
                  />
                  <rect
                    width="16.217"
                    height="1.634"
                    rx="0.817"
                    transform="translate(23.005 7.165)"
                    fill={theme.imageHighlight}
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    );
  }
}
